import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// I18n
import { useTranslation } from "react-i18next";
// Router
import { useHistory } from "react-router-dom";
// MUI
import {
  Grid,
  Button,
  InputAdornment,
  makeStyles,
  useTheme,
  TextField,
  Box,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
// Components
import CardLayout from "../CardLayout";
import {
  ALL_ACTIVITIES,
  MANAGE_WORKERS,
  REVIEW,
  MANAGE_TIMESHEET,
} from "navigation/CONSTANTS";
import {
  getManagerEmails,
  selectedManagerForApproval,
  selectedTeamOnReview,
} from "redux/actions/appActions";
import { isEmptyObject, properCase } from "utils/index";
import { MANAGE_FOR_BY_COUNTRY, OTHER_TEAM } from "config/CONSTANTS";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { IconButton } from "@material-ui/core";
import CircularButton from "components/CircularButton";
import { getWorkerIMTimeRole } from "services/workerSchedule";

import { getParentManager } from "services";

const useStyles = makeStyles((theme) => ({
  color: {
    color: theme.grey,
  },
  outerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 120,
  },
  innerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const ApproveForView = () => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();

  const { user } = useSelector((state) => state.user.auth);
  const appConfig = useSelector((state) => state.appConfig);
  const [managerOptions, setManagerOptions] = useState([]);
  const [selectedManager, setSelectedManager] = useState({});
  const [disableSearch, setDisableSearch] = useState(true);

  //This useEffect and useState has been written to show only those names in the manage for for which I am the approving manager
  const [newOptions, setNewOptions] = useState([]);
  const [imtRole, setImtRole] = useState("");
  const [allApprovers, setAllApprovers] = useState([]);

  //filter is used to remove the duplicates
  useEffect(() => {
    if (user && appConfig && appConfig.managerEmails !== null) {
      getWorkerIMTimeRole(user.workerId).then((data) => {
        setImtRole(data.role);
      });
      console.log("Handle Manager ");
      getParentManager(user.workerId).then((querySnapshot) => {
        let optionsAvailable = querySnapshot.filter(
          (elem, index) =>
            querySnapshot.findIndex(
              (obj) => obj.managerId === elem.managerId
            ) === index
        );
        let delegateFor = user?.delegateFor;
        if (delegateFor && delegateFor.length > 0) {
          if (optionsAvailable.length > 0) {
            delegateFor = delegateFor.filter(id => !optionsAvailable.find(element => element.managerId === id));
          }
          if (delegateFor.length > 0) {
            let managerDetails = appConfig.managerEmails;
            managerDetails = managerDetails.filter(
              (record) => delegateFor.includes(record.managerId)
            );
            optionsAvailable = [...optionsAvailable, ...managerDetails]
          }
        }
        setNewOptions(optionsAvailable);
      });
    }
  }, [user, appConfig.managerEmails]);

  //for showing country managers and those for whom you are delegating
  const [loggedinPlusDelegate, setLoggedinPlusDelegate] = useState([]);

  useEffect(() => {
    if (user) {
      let loggedinCountryManagers = managerOptions.filter(
        (item) => item.managerCountry === user.country
      );

      let totalManagers = [...loggedinCountryManagers, ...newOptions];

      let removeRepeated = totalManagers.filter(
        (elem, index) =>
          totalManagers.findIndex((obj) => obj.managerId === elem.managerId) ===
          index
      );
      setLoggedinPlusDelegate(removeRepeated);
      setAllApprovers(managerOptions);
    }
  }, [newOptions]);

  const reviewNavigation = () => {
    if (!isEmptyObject(selectedManager)) {
      dispatch(selectedManagerForApproval(selectedManager));
      dispatch(selectedTeamOnReview({ team: OTHER_TEAM }));
      history.push(MANAGE_TIMESHEET, { isTimesheetView: true });
    }
  };
  const manageWorkersNavigation = () => {
    if (!isEmptyObject(selectedManager)) {
      dispatch(selectedManagerForApproval(selectedManager));
      dispatch(selectedTeamOnReview({ team: OTHER_TEAM }));
      history.push(MANAGE_WORKERS, { isManageWorkers: true });
    }
  };
  const handleManagerChange = (event, newValue) => {
    if (newValue && newValue !== null && typeof newValue === "object") {
      setDisableSearch(false);
      setSelectedManager(newValue);
    } else {
      setDisableSearch(true);
    }
  };

  useEffect(() => {
    if (appConfig && appConfig.managerEmails !== null) {
      let managerDetails = appConfig.managerEmails;
      managerDetails = managerDetails.filter(
        (record) => record.managerId !== user.workerId
      );
      setManagerOptions(managerDetails);
    }
  }, [user, appConfig.managerEmails]);

  const manageForOptions = () => {
    switch (imtRole) {
      case "Admin":
        return allApprovers;
        break;
      case "Support":
        return allApprovers;
        break;
      case "Super User":
        return loggedinPlusDelegate;
        break;
      case "Supervisor":
        return newOptions;
        break;
      default:
        return newOptions;
    }
  };

  return (
    <CardLayout title={properCase(t("pgHome.tlApproveFor"))}>
      <Box className={classes.outerContainer} width="100%">
        <Box className={classes.innerContainer} width="100%">
          <Box
            container
            component={Grid}
            alignItems="center"
            spacing={1}
            width="100%"
            justifyContent="center"
          >
            <Grid item md={8} sm={8} xs={8} lg={8} xl={8}>
              <Autocomplete
                options={manageForOptions()}
                freeSolo
                getOptionLabel={(option) =>
                  option && option.managerFirstName
                    ? option.managerFirstName + " " + option.managerLastName
                    : ""
                }
                id="employeeSearch"
                classes={{ inputRoot: classes.color }}
                size="small"
                onChange={(event, worker) =>
                  handleManagerChange(event, worker, true)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={t("other.searchManager")}
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* <Box pl={1}> */}

            <Grid item>
              <CircularButton
                disabled={disableSearch}
                onClick={reviewNavigation}
              >
                {/* {t("other.activity")} */}
              </CircularButton>
            </Grid>
          </Box>
          {/* </Box> */}
        </Box>
        {/* <Grid item md={8} sm={8} xs={8} >
            </Grid>
          <Grid item md={8} sm={8} xs={8} >
            </Grid>                       */}
        {/* <Grid item>
              <Button
                variant="contained"
                color="primary"
                disabled={disableSearch}
                onClick={manageWorkersNavigation}
              >
                {t("other.workers")}
                
              </Button>
            </Grid> */}
      </Box>
      {/* </Grid> */}
    </CardLayout>
  );
};

export default ApproveForView;
